// src/com/file_create_his/FileCreateHisDict.js
import { InputType, TableColumnType } from "../../value/AppConst";
import IsValid from "../../value/IsValid";

const Dict = {
    // toAdd, toEdit : mark if need to submit for mutation
    dateFrom: {
        id: 'dateFrom', label: '시작일',
        type: InputType.date, required: false, toAdd: true, toEdit: true,
        check: (value) => {return IsValid.date(value)},
    },
    dateTill: {
        id: 'dateTill', label: '종료일',
        type: InputType.date, required: false, toAdd: true, toEdit: true,
        check: (value) => {return IsValid.date(value)},
    },
};
/*
export const fchDeliveryReportListRepo = makeVar({when:0, records:[]}); // fileCreateHis: 출고실적 리포트 조회
export const fchTransportReportListRepo = makeVar({when:0, records:[]}); // fileCreateHis: 운송실적 리포트 조회
export const fchArrivalOnTimeReportListRepo = makeVar({when:0, records:[]}); // fileCreateHis: 정시도착 리포트 조회
export const fchTemperatureReportListRepo = makeVar({when:0, records:[]}); // fileCreateHis: 온도관제 리포트 조회
export const fchTsrResultReportListRepo = makeVar({when:0, records:[]}); // fileCreateHis: TSR결과 리포트 조회
export const fchStoreTransportReportListRepo = makeVar({when:0, records:[]}); // fileCreateHis: 점포운송 리포트 조회

*/

/**
 * FILE_CREATE_HIS React Component Dictionary for Input and Output
 * Project: NewTOP for cloud
 * 2024-10-11 09:49:45 using DbdbTap
 */
export const FileCreateHisDictionary = {
    inputMap: Dict,
    maxPeriod: 90, // days
    errorDeliveryTitle: { // menu: AppMenuUrl.UnStoreResultReport
        Add: '출고실적 리포트 생성 요청 오류',
        Remove: '출고실적 리포트 삭제 오류',
        Get: '출고실적 리포트 조회 오류',
    },
    errorTransportTitle: { // menu: AppMenuUrl.TransPlanReport
        Add: '운송실적 리포트 생성 요청 오류',
        Remove: '운송실적 리포트 삭제 오류',
        Get: '운송실적 리포트 조회 오류',
    },
    errorArrivalOnTimeTitle: { // menu: AppMenuUrl.OnTimeArriveReport
        Add: '정시도착 리포트 생성 요청 오류',
        Remove: '정시도착 리포트 삭제 오류',
        Get: '정시도착 리포트 조회 오류',
    },
    errorTemperatureTitle: { // menu: AppMenuUrl.TempReport
        Add: '온도관제 리포트 생성 요청 오류',
        Remove: '온도관제 리포트 삭제 오류',
        Get: '온도관제 리포트 조회 오류',
    },
    errorTsrResultTitle: { // menu: AppMenuUrl.TSRResultReport
        Add: 'TSR결과 리포트 생성 요청 오류',
        Remove: 'TSR결과 리포트 삭제 오류',
        Get: 'TSR결과 리포트 조회 오류',
    },
    errorStoreTransportTitle: { // menu: AppMenuUrl.StoreTransReport
        Add: '점포운송 리포트 생성 요청 오류',
        Remove: '점포운송 리포트 삭제 오류',
        Get: '점포운송 리포트 조회 오류',
    },
    tableProps: {
        // tableId: 'fileCreateHisTable',
        deleveryReportId: 'fchDeliveryReport',
        transportReportId: 'fchTransportReport',
        arrivalOnTimeReportId: 'fchArrivalOnTimeReport',
        temperatureReportId: 'fchTemperatureReport',
        tsrResultReportId: 'fchTsrResultReport',
        storeTransportReportId: 'fchStoreTransportReport',
        uniqueKey: 'fileCreateHisSeq',
        flexOption: {
            multiChecker:false,
            hideFirstTopButton: false,
            hideColumnConfig: true,
            hideBubble: false,
            growToFill: true,
        },
        columns: [
            //print using getTableColumnOption(c,t,i)
            //{ id: 'fileCreateHisSeq', label: Dict.fileCreateHisSeq.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'fileName', label: '파일명', width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'fileTitle', label: '기간', width: 280, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'fileSize', label: '사이즈(Kb)', width: 90, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'dcCd', label: '센터코드', width: 90, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            /* { id: 'fileAddr', label: Dict.fileAddr.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'fileDownUp', label: Dict.fileDownUp.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'fileFlag', label: Dict.fileFlag.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'menuName', label: Dict.menuName.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'serverUrl', label: Dict.serverUrl.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'fileExt', label: Dict.fileExt.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            */
            { id: 'regUserName', label: "등록자", width: 100, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'regDate', label: "등록일", width: 120, show: true, option:{align: 'center', print:(r,i,v)=>v?v.substring(0,16):'-'} },
            
        ]
    },
};
